import React from "react";

const WFIRSSQuestion2 = ({ questions, renderRadioInputs, questionKey }) => (
  <div key={`WFIRSSQuestion2${questionKey}`}>
    <div className="wfirs-progress-row">
      <div className="wfirs-progress-bar">
        <div style={{ width: "28.6%" }}></div>
      </div>
      <span className="wfirs-counter">2 / 7</span>
    </div>
    <h2 className="wfirs-section-title">Click the number for the rating that best describes how your emotional or behavioral problems have affected your Work Skills.</h2>
    {questions.slice(8, 19).map((question, index) => (
      <div className="wfirs-question" key={index}>
        <label className="wfirs-q-label">{index + 9}. {question.questions}</label>
        {renderRadioInputs(index + 9)}
      </div>
    ))}
  </div>
);

export default WFIRSSQuestion2;
